export default class DataLayerManager {
    push(name, data) {
        let url = window.location.pathname;
        window.dataLayer.push({
            event: name,
            url: url,
            ...data
        });
    }
}